import { render, staticRenderFns } from "./ActividadesEditar.vue?vue&type=template&id=e5bd4392"
import script from "./ActividadesEditar.vue?vue&type=script&lang=js"
export * from "./ActividadesEditar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports